<template>
  <v-row align="center">
    <v-col align-self="center">
      <v-card
        :loading="loading"
        outlined
        elevation="0"
        class="mx-auto my-12"
        max-width="450"
        style="text-align: center"
      >
        <template slot="progress">
          <v-progress-linear
            color="primary"
            height="2"
            indeterminate
          ></v-progress-linear>
        </template>

        <logo width="70" height="70" />

        <h2 class="px-16 primary--text">Vamos a reestablecer tu contraseña!</h2>
        <v-card-text class="px-16 description-text">Por favor ingresa a continuación tu usuario, número de identificación, el código que enviamos a tu email y la nueva contraseña</v-card-text>

        <v-card-text class="px-16">
          <v-form
            ref="resetPasswordForm"
            lazy-validation
            v-model="valid"
          >
            <v-text-field
              label="Usuario"
              outlined
              dense
              filled
              type="text"
              :rules="[rules.required]"
              v-model="usuario"
            ></v-text-field>

            <v-text-field
              label="Número de identificación"
              outlined
              dense
              filled
              type="number"
              :rules="[rules.required]"
              v-model="n_identififacion"
            ></v-text-field>

            <v-text-field
              label="Código"
              outlined
              dense
              filled
              type="text"
              :rules="[rules.required]"
              v-model="codigo"
            ></v-text-field>

            <v-text-field
              :append-icon="mostrarContrasena ? 'mdi-eye-off' : 'mdi-eye'"
              :rules="[rules.required, rules.password]"
              :type="mostrarContrasena ? 'text' : 'password'"
              name="input-10-2"
              label="Contraseña"
              hint="Al menos 8 caracteres"
              class="input-group--focused"
              outlined
              dense
              filled
              v-model="contrasena"
              @click:append="mostrarContrasena = !mostrarContrasena"
            ></v-text-field>
          </v-form>
        </v-card-text>

        <v-card-actions class="px-16 pb-10">
          <v-row>
            <v-col cols="12">
              <v-btn
                color="primary"
                depressed
                block
                @click="resetPassword"
              >
                Reestablecer
              </v-btn>
            </v-col>
            <v-col cols="12">
              <a
                class="text--primary"
                @click="$router.push('/login')"  
              >Iniciar sesión</a>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import logo from '@/components/logo.vue'
import { POST } from '@/boot/http'
import eventBus from '@/boot/eventBus'
import { mapGetters } from 'vuex'
// import { POST } from '@/boot/http'
// import eventBus from '@/boot/eventBus'

export default {
  name: 'ResetPassword2',
  data: () => ({
    usuario: '',
    n_identififacion: '',
    codigo: '',
    contrasena: '',
    valid: true,
    mostrarContrasena: false,
    rules: {
      required: value => !!value || 'Requerido',
      password: val => val.length > 7 || 'Minimo 8 caracteres'
    },
    loading: false
  }),
  methods: {
    resetPassword () {
      const valid = this.$refs.resetPasswordForm.validate()
      if (valid) {
        const { usuario, n_identififacion, codigo, contrasena } = this
        POST({
          url: 'recordarpwd/changepwd',
          data: {
            p_datajson: {
              usuario,
              n_identififacion,
              codigotemporal: codigo,
              contrasena
            },
            p_opc: 'CHANGE_PWD',
            p_auditoriajson: { usuario_id: 0 }
          }
        }).then(data => {
          if (data.data.status.status === 'ok') {
            eventBus.$emit('modal', { value: true, title: 'Exito!', text: 'Se ha reestablecido la contraseña', color: 'primary' })
            this.$router.push('/login')
          } else {
            eventBus.$emit('modal', { value: true, title: 'Error', text: data.data.status.mensaje, color: 'error' })
          }
        }).catch(error => {
          eventBus.$emit('modal', { value: true, title: 'Error', text: error.message, color: 'error' })
        })
      }
    }
  },
  components: { logo },
  computed: {
    ...mapGetters(['getUserData'])
  }
}
</script>

<style scoped>
  .description-text {
    line-height: 1rem;
    font-size: 0.85rem
  }
</style>